import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'

import { CustomDatePicker } from '../../../datepicker'
import { Input } from '../../../input'
import { MovementDropdown } from '../../movement/movement-dropdown'
import { Button } from '../../../buttons'

import { CompanyInfoFirstCol } from './first-column'
import { CompanyInfoSecondCol } from './second-column'

import { FONTS } from '../../../../constants'

export const MovementInfo = React.memo(props => {
  const {
    emp,
    movementData,
    invalid,
    invalidModule,
    movements,
    _companys,
    _lobs,
    _positions,
    _departments,
    _divisions,
    _teams,
    isEditMovement,
    handleClickEdit,
    handleClickCancel,
    handleClickSaveMovement,
    handleDeleteMovement,
    handleChangeMovement,
    handleInput,
    handleCheckbox,
    handleClickNewMovement,
  } = props

  return (
    <Root>
      <Container>
        <MovementSection>
          <DropdownWrapper>
            <MovementDropdown
              emp={ emp }
              movementData={ movementData }
              movements={ movements }
              isEditMovement={ isEditMovement }
              handleChangeMovement={ handleChangeMovement }
            />
            <Button
              theme='#28a745'
              width='150px'
              height='30px'
              disabled={ isEditMovement }
              onClick={ handleClickNewMovement }
            >
              New Movement
            </Button>
          </DropdownWrapper>
          <FormGroup>
            <FormWrapper>
              <Label required>Movement Name</Label>
              <Input
                name='name'
                placeholder='Enter Movement Name'
                invalid={ invalid['name'] }
                disabled={ !isEditMovement }
                value={ movementData.name || '' }
                onChange={ e => handleInput(e.target.value, 'name') }
              />
            </FormWrapper>
            <FormWrapper>
              <Label required>Start Date</Label>
              <CustomDatePicker
                showYearDropdown
                showMonthDropdown
                autoComplete='off'
                name='start_date'
                dateFormat='DD/MM/YYYY'
                invalid={ invalid['start_date'] }
                disabled={ !isEditMovement }
                selected={ movementData.start_date ? moment(movementData.start_date) : null }
                onChange={ e => handleInput(e, 'start_date') }
              />
            </FormWrapper>
          </FormGroup>
          <FormGroup>
            <MovementWrapper>
              <Label>Description (Remarks)</Label>
              <Input
                name='description'
                placeholder='Enter Description'
                disabled={ !isEditMovement }
                value={ movementData.description || '' }
                onChange={ e => handleInput(e.target.value, 'description') }
              />
            </MovementWrapper>
          </FormGroup>
        </MovementSection>
        <Form>
          <CompanyInfoFirstCol
            _companys={ _companys }
            _lobs={ _lobs }
            _positions={ _positions }
            _departments={ _departments }
            movementData={ movementData }
            isEditMovement={ isEditMovement }
            handleInput={ handleInput }
          />
          <CompanyInfoSecondCol
            _divisions={ _divisions }
            _teams={ _teams }
            invalidModule={invalidModule}
            movementData={ movementData }
            isEditMovement={ isEditMovement }
            handleInput={ handleInput }
            handleCheckbox={ handleCheckbox }
          />
        </Form>
      </Container>
      <Footer>
        { isEditMovement ?
          <ButtonWrapper>
            <Button
              outline
              theme='#D44B49'
              width='145px'
              height='26px'
              onClick={ () => handleDeleteMovement(movementData._id) }
            >
              Delete this movement
            </Button>
            <ButtonGroup>
              <Button
                theme='#28a745'
                icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
                width='70px'
                height='26px'
                disabled={ Object.keys(invalid).length > 0 || invalidModule }
                onClick={ handleClickSaveMovement }
              >
                Save
              </Button>
              <Button
                theme='#6c757d'
                width='70px'
                height='26px'
                onClick={ () => handleClickCancel(movementData.user_id) }
              >
                Cancel
              </Button>
            </ButtonGroup>
          </ButtonWrapper>
          :
          <Button
            theme='#28a745'
            icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => handleClickEdit(2) }
          >
          Edit
          </Button>
        }
      </Footer>
    </Root>
  )
})

const Root = styled.div`
    display: flex;
    flex-direction: column;
`

const Container = styled.div`
    padding: 16px 24px;
    background: #FFFFFF;
    max-height: calc(100vh - 223px);
    overflow-y: scroll;
`

const Footer = styled.div`
    height: 42px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #F9F9F9;
    padding: 0 24px;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const Form = styled.div`
  display: flex;
  background: #F9F9F9;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  padding: 12px;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-child(1) {
      margin-right: 12px;
    }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`

const MovementSection = styled.div`
  display: flex;
  flex-direction: column;
`

const MovementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-left: 8px;
  }
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/movement-info/index.js